import { affiliateMerchants } from "../../settings/affiliate";
import namedRoutes from "../../settings/routes";
import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

const brand = "BLUETTI";
const rawData: PowerStationInternal[] = [
  // No DC
  {
    name: "FridgePower",
    link: {
      href: "https://www.bluettipower.com/products/fridgepower-battery-backup?id=6a2a69d42b71fb8ff494a178&variant=48862781210843",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GX1GHYMM/",
      affiliate: "https://amzn.to/4evMgbL",
    },
    img: "/images/products/bluetti/fridgepower/front.webp",

    price: 849,
    capacity: 2016,
    acOutput: 1800,
    //dcOutput: 10,
    solar: 1000,
  },

  // Low DC
  {
    name: "Elite 200 V2",
    link: {
      href: "https://www.bluettipower.com/products/elite-200-v2-portable-power-station",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GCCBYD21/",
      affiliate: "https://amzn.to/4sHtK57",
    },
    img: "/images/products/bluetti/elite-200-v2/front.webp",

    price: 899,
    capacity: 2073.6,
    acOutput: 2600,
    dcOutput: 10,
    solar: 1000,

    displayPowerSystemsPage: true,
  },
  {
    name: "Elite 100 V2 Bio-based",
    link: {
      href: "https://www.bluettipower.com/products/bluetti-elite-100-v2-portable-power-station-1-800w-1-024wh-bio-based?variant=48108775407835",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GCCBYD21/",
      affiliate: "https://amzn.to/4tfsvva",
    },
    img: "/images/products/bluetti/elite-100-v2/front.webp",

    price: 499,
    capacity: 1024,
    acOutput: 1800,
    dcOutput: 10,
    solar: 1000,

    displayPowerSystemsPage: true,
  },
  {
    name: "AC180",
    link: {
      href: "https://www.bluettipower.com/products/ac180?variant=44099774480603",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0C1SMJTDT/",
      affiliate: "https://amzn.to/3OEgbFA",
    },
    img: "/images/products/bluetti/ac180/front.webp",

    price: 499,
    capacity: 1152,
    acOutput: 1800,
    dcOutput: 10,
    solar: 500,
    expandable: true,

    displayPowerSystemsPage: true,
  },

  // Only on BLUETTI page
  {
    name: "Elite 400",
    link: {
      href: "https://www.bluettipower.com/products/elite-400-portable-power-station",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0G8Y8DCC1/",
      affiliate: "https://amzn.to/4mDuWFk",
    },
    img: "/images/products/bluetti/elite-400/front.webp",

    price: 1399,
    capacity: 3840,
    acOutput: 1600,
    dcOutput: 10,
    solar: 1000,
  },
  // {
  //   name: "Elite 200 V2",
  //   link: {
  //     href: "https://www.bluettipower.com/products/elite-200-v2-portable-power-station",
  //     affiliateData: affiliateMerchants.bluetti,
  //     icon: "Bluetti",
  //   },
  //   amazon: {
  //     href: "",
  //     affiliate: "",
  //   },
  //   img: "/images/products/bluetti/elite-200-v2/front.webp",

  //   price: 799,
  //   capacity: 2073.6,
  //   acOutput: 0,
  //   dcOutput: 0,
  //   solar: 0,
  // },
  // {
  //   name: "AC180",
  //   link: {
  //     href: "https://www.bluettipower.com/products/ac180?variant=44099774480603",
  //     affiliateData: affiliateMerchants.bluetti,
  //     icon: "Bluetti",
  //   },
  //   amazon: {
  //     href: "",
  //     affiliate: "",
  //   },
  //   img: "/images/products/bluetti/ac180/front.webp",

  //   price: 449,
  //   capacity: 1152,
  //   acOutput: 0,
  //   dcOutput: 0,
  //   solar: 0,
  // },
  // {
  //   name: "Elite 100 V2",
  //   link: {
  //     href: "https://www.bluettipower.com/products/bluetti-elite-100-v2-portable-power-station-1-800w-1-024wh-bio-based?id=685b73e8258285bb41303d8c&variant=47048282177755",
  //     affiliateData: affiliateMerchants.bluetti,
  //     icon: "Bluetti",
  //   },
  //   amazon: {
  //     href: "https://www.amazon.com/dp/B0F42TNLVH/",
  //     affiliate: "https://amzn.to/4tqVgoQ",
  //   },
  //   img: "/images/products/bluetti/elite-100-v2/front.webp",

  //   price: 429,
  //   capacity: 1024,
  //   acOutput: 1800,
  //   dcOutput: 10,
  //   solar: 1000,
  // },
  {
    name: "Pioneer Na",
    link: {
      href: "https://www.bluettipower.com/products/sodium-ion-battery-pioneer-na?variant=47699009143003",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    // amazon: {
    //   href: "",
    //   affiliate: "",
    // },
    img: "/images/products/bluetti/pioneer-na/front.webp",

    price: 899,
    capacity: 900,
    acOutput: 1500,
    dcOutput: 10,
    solar: 500,
  },
  {
    name: "AC70",
    link: {
      href: "https://www.bluettipower.com/products/ac70?variant=46848026804443",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0CLG6FYLQ/",
      affiliate: "https://amzn.to/3QgY8ps",
    },
    img: "/images/products/bluetti/ac70/front.webp",

    price: 359,
    capacity: 768,
    acOutput: 1000,
    dcOutput: 10,
    solar: 500,
    expandable: true,
  },
  {
    name: "AC50B",
    link: {
      href: "https://www.bluettipower.com/products/ac50b?variant=45778244960475",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0CZ6P84WH/",
      affiliate: "https://amzn.to/4vy96qR",
    },
    img: "/images/products/bluetti/ac50b/front.webp",

    price: 279,
    capacity: 448,
    acOutput: 700,
    dcOutput: 10,
    solar: 200,
  },
  {
    name: "Elite 30 V2",
    link: {
      href: "https://www.bluettipower.com/products/elite-30-v2-portable-power-station?variant=47190054568155",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0F42HLLSC/",
      affiliate: "https://amzn.to/4dPrgOl",
    },
    img: "/images/products/bluetti/elite-30-v2/front.webp",

    price: 239,
    capacity: 288,
    acOutput: 600,
    dcOutput: 10,
    solar: 200,
  },
  {
    name: "AC2A",
    link: {
      href: "https://www.bluettipower.com/products/ac2a?variant=44389797789915",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0CLGZW9WD/",
      affiliate: "https://amzn.to/4u0nsid",
    },
    img: "/images/products/bluetti/ac2a/front.webp",

    price: 149,
    capacity: 204,
    acOutput: 300,
    dcOutput: 10,
    solar: 100,
  },

  // High DC
  {
    name: "Elite 300",
    link: {
      href: "https://www.bluettipower.com/products/elite-300-portable-power-station",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GKRTX336/",
      affiliate: "https://amzn.to/4251luR",
    },
    img: "/images/products/bluetti/elite-300/front-left.webp",

    price: 1199,
    capacity: 3014,
    acOutput: 2400,
    dcOutput: 30,
    solar: 1200,
    solar2: 0,
    expandable: false,

    displayPowerSystemsPage: true,
  },
  {
    name: "AC200L",
    review: namedRoutes.bluetti.ac200l,
    link: {
      href: "https://www.bluettipower.com/products/ac200l-portable-power-station",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0CLGZB3L6/",
      affiliate: "https://amzn.to/3Q6jLIN",
    },
    img: "/images/products/bluetti/ac200l/front-left.webp",

    price: 899,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 10,
    dcOutput2: 50,
    solar: 1200,
    solar2: 0,
    expandable: true,

    captions: {
      dcOutput2: "Requires BLUETTI Charger 2 + DC Hub.",
    },

    //displayPowerSystemsPage: true,
  },
  {
    name: "Apex 300",
    link: {
      href: "https://www.bluettipower.com/products/apex-300-home-battery-backup?id=68804e7e63e18b529ef2604a&variant=47351562174683",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0F42JY551/",
      affiliate: "https://amzn.to/48xxted",
    },
    img: "/images/products/bluetti/apex-300/front-left.webp",

    price: 1499,
    capacity: 3840,
    acOutput: 3840,
    dcOutput: 0,
    dcOutput2: 50,
    solar: 1200,
    solar2: 1200,
    expandable: true,

    captions: {
      dcOutput2: "Requires BLUETTI Hub D1 or BLUETTI Charger 2 + DC Hub.",
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "Apex 200",
    review: namedRoutes.bluetti.apex200,
    link: {
      href: "https://www.bluettipower.com/pages/apex-200-expandable-power-station",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    // amazon: {
    //   href: "https://www.amazon.com/dp/B0F42JY551/",
    //   affiliate: "https://amzn.to/48xxted",
    // },
    img: "/images/products/bluetti/apex-200/front-left.webp",

    price: 1099,
    capacity: 2560,
    acOutput: 3200,
    dcOutput: 30,
    dcOutput2: 50,
    solar: 2000,
    solar2: 1000,
    expandable: true,

    captions: {
      dcOutput2: "Requires BLUETTI Hub D1 or BLUETTI Charger 2 + DC Hub.",
    },

    displayPowerSystemsPage: true,
  },

  // Modular
  {
    name: "RV5",
    review: namedRoutes.bluetti.rv5,
    link: {
      href: "https://www.bluettipower.com/products/rv5-rv-solar-system?id=68da7c684197d774e9a80362&variant=47637171503323",
      affiliateData: affiliateMerchants.bluetti,
      icon: "Bluetti",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0G13DFFL5/",
      affiliate: "https://amzn.to/4cc3GtR",
    },

    img: "/images/products/bluetti/rv5/rv5_b4810_epanel_epad.webp",

    price: 3699,
    capacity: 5120,
    capacityMin: 5120,
    capacityMax: 122880,
    acOutput: 5000,
    dcOutput: 100,
    solar: 1800,
    solar2: 1800,
    expandable: true,
    modular: true,

    displayPowerSystemsPage: true,
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
